/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function LockIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "lock", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M7.5 11.5H17.5V19.5H7.5V11.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.5 11.5V8.5C9.5 6.5 10.5 5.5 12.5 5.5C14.5 5.5 15.5 6.5 15.5 8.5V11.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(LockIcon);
export default ForwardRef;
//# sourceMappingURL=lockIcon.js.map